import React from "react";
import {
	CarOutlined,
	BorderOutlined,
	HomeOutlined,
	AppstoreOutlined,
	UnorderedListOutlined,
	ToolOutlined,
	PlusOutlined,
	InfoOutlined,
	UserOutlined,
} from "@ant-design/icons";

import { PERMISSION } from "../constants";
import { APP_PATH } from "../constants/path";
import { lazyRetry } from "utils/route";
import { isStag } from "utils/environment";

// showrooms
const Showrooms = React.lazy(() =>
	lazyRetry(() => import("../features/showroom")),
);
const Showroom = React.lazy(() =>
	lazyRetry(() => import("../features/showroom/detail")),
);

// brands
const Brands = React.lazy(() => lazyRetry(() => import("../features/brand")));
const Brand = React.lazy(() =>
	lazyRetry(() => import("../features/brand/Brand")),
);

// models
const Models = React.lazy(() => lazyRetry(() => import("../features/model")));
const Model = React.lazy(() =>
	lazyRetry(() => import("../features/model/Model")),
);

//category
const CategoryList = React.lazy(() =>
	lazyRetry(() => import("../features/category/CategoryList")),
);
const CategoryCreate = React.lazy(() =>
	lazyRetry(() => import("../features/category/CategoryCreate")),
);
const CategoryDetail = React.lazy(() =>
	lazyRetry(() => import("../features/category/CategoryDetail")),
);

// part types
const PartTypes = React.lazy(() =>
	lazyRetry(() => import("../features/part-type")),
);
const PartType = React.lazy(() =>
	lazyRetry(() => import("../features/part-type/PartType")),
);

// car care category
const CarCareCategories = React.lazy(() =>
	lazyRetry(() => import("../features/car-care-category")),
);
const CarCareCategory = React.lazy(() =>
	lazyRetry(() => import("../features/car-care-category/CarCareCategory")),
);

// partner
const Partners = React.lazy(() =>
	lazyRetry(() => import("../features/partner")),
);
const Partner = React.lazy(() =>
	lazyRetry(() => import("../features/partner/detail")),
);

// product support type
const ProductSupportTypes = React.lazy(() =>
	lazyRetry(() => import("../features/product-support-type")),
);

const ProductSupportTypeDetail = React.lazy(() =>
	lazyRetry(() => import("../features/product-support-type/detail")),
);

// Rescue stores
const RescueStores = React.lazy(() =>
	lazyRetry(() => import("../features/rescue-stores")),
);

const RescueStoreDetail = React.lazy(() =>
	lazyRetry(() => import("../features/rescue-stores/detail")),
);

const masterDataRoutes = {
	label: "Master data",
	path: "",
	key: "master-data",
	icon: <UnorderedListOutlined />,
	children: [
		/* showrooms routes */
		{
			label: "Testing places",
			path: APP_PATH.showrooms,
			key: "showrooms",
			component: <Showrooms />,
			icon: <HomeOutlined />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Create testing place",
			path: `${APP_PATH.showroomCreate}`,
			key: "showrooms",
			component: <Showroom />,
			icon: <BorderOutlined />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Testing place detail",
			path: `${APP_PATH.showrooms}/:id`,
			key: "showrooms",
			component: <Showroom />,
			icon: <BorderOutlined />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		// Brand
		{
			label: "Brands",
			path: APP_PATH.brands,
			key: "brands",
			icon: <CarOutlined />,
			children: [],
			component: <Brands />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Brand details",
			path: `${APP_PATH.brands}/:id`,
			key: "brands",
			icon: <CarOutlined />,
			hidden: true,
			children: [],
			component: <Brand />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Brand create",
			path: APP_PATH.brandCreate,
			key: "brands",
			icon: <CarOutlined />,
			hidden: true,
			children: [],
			component: <Brand />,
			permissions: [PERMISSION.CONFIG.CREATE],
		},
		// Model
		{
			label: "Models",
			path: APP_PATH.models,
			key: "models",
			icon: <CarOutlined />,
			children: [],
			component: <Models />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Model detail",
			path: `${APP_PATH.models}/:id`,
			key: "models",
			icon: <CarOutlined />,
			hidden: true,
			children: [],
			component: <Model />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Model create",
			path: APP_PATH.modelCreate,
			key: "models",
			icon: <CarOutlined />,
			hidden: true,
			children: [],
			component: <Model />,
			permissions: [PERMISSION.CONFIG.CREATE],
		},
		//Category
		{
			label: "Categories",
			path: APP_PATH.categories,
			key: "categories",
			icon: <AppstoreOutlined />,
			children: [],
			component: <CategoryList />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Category detail",
			path: `${APP_PATH.categories}/:id`,
			key: "categories-detail",
			icon: <AppstoreOutlined />,
			hidden: true,
			component: <CategoryDetail />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Category create",
			path: APP_PATH.categoriesCreate,
			key: "categories-create",
			icon: <AppstoreOutlined />,
			hidden: true,
			component: <CategoryCreate />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		//Part types
		{
			label: "Part types",
			path: APP_PATH.partTypes,
			key: "part-types",
			icon: <ToolOutlined />,
			children: [],
			component: <PartTypes />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Create part type",
			path: APP_PATH.partTypeCreate,
			key: "partTypeCreate",
			icon: <PlusOutlined />,
			component: <PartType />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.CREATE],
		},
		{
			label: "Part type detail",
			path: APP_PATH.partType,
			key: "partType",
			icon: <InfoOutlined />,
			component: <PartType />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		//Car Wash Categry
		{
			label: "Car care categories",
			path: APP_PATH.carCareCategories,
			key: "car-care-categories",
			icon: <AppstoreOutlined />,
			children: [],
			component: <CarCareCategories />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Create car care category",
			path: APP_PATH.carCareCategoryCreate,
			key: "carCareCategoryCreate",
			icon: <PlusOutlined />,
			component: <CarCareCategory />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.CREATE],
		},
		{
			label: "Car care category detail",
			path: APP_PATH.carCareCategory,
			key: "carCareCategory",
			icon: <InfoOutlined />,
			component: <CarCareCategory />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		// Partner
		{
			label: "Partner",
			path: APP_PATH.partners,
			key: "partners",
			icon: <UserOutlined />,
			// children: [],
			component: <Partners />,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Create partner",
			path: APP_PATH.partnerCreate,
			key: "partnerCreate",
			icon: <UserOutlined />,
			component: <Partner />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.CREATE],
		},
		{
			label: "Partner detail",
			path: APP_PATH.partner,
			key: "partner",
			icon: <UserOutlined />,
			component: <Partner />,
			hidden: true,
			permissions: [PERMISSION.CONFIG.VIEW],
		},
		// Product Support Types
		{
			label: "Support Type",
			path: APP_PATH.productSupportTypes,
			key: "product-support-types",
			icon: <AppstoreOutlined />,
			component: <ProductSupportTypes />,
			// permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Create support type",
			path: APP_PATH.productSupportTypeCreate,
			key: "productSupportTypeCreate",
			icon: <AppstoreOutlined />,
			children: [],
			component: <ProductSupportTypeDetail />,
			hidden: true,
			// permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Update support type",
			path: APP_PATH.productSupportTypeUpdate,
			key: "productSupportTypeUpdate",
			icon: <AppstoreOutlined />,
			children: [],
			component: <ProductSupportTypeDetail />,
			hidden: true,
			// permissions: [PERMISSION.CONFIG.VIEW],
		},
		// Rescue stores
		{
			label: "Support Location",
			path: APP_PATH.rescueStores,
			key: "rescue-stores",
			icon: <AppstoreOutlined />,
			component: <RescueStores />,
			// permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Create support type",
			path: APP_PATH.rescueStoreCreate,
			key: "rescueStoreCreate",
			icon: <AppstoreOutlined />,
			children: [],
			component: <RescueStoreDetail />,
			hidden: true,
			// permissions: [PERMISSION.CONFIG.VIEW],
		},
		{
			label: "Update support type",
			path: APP_PATH.rescueStoreUpdate,
			key: "rescueStoreUpdate",
			icon: <AppstoreOutlined />,
			children: [],
			component: <RescueStoreDetail />,
			hidden: true,
			// permissions: [PERMISSION.CONFIG.VIEW],
		},
	],
};

export default masterDataRoutes;
